/***********************
 * TRACK FUNNEL BATCH MDL
 * ----------------------------------------------------------
 * RÔLE
 * ----------------------------------------------------------
 * Batch local des événements funnel React avant envoi Apps Script.
 *
 * OBJECTIF
 * ----------------------------------------------------------
 * Réduire :
 * - saturation webhook ;
 * - spam événements ;
 * - verrous Apps Script ;
 * - écritures Google Sheets.
 *
 * STRATÉGIE
 * ----------------------------------------------------------
 * - stockage mémoire local ;
 * - flush automatique toutes les 30s ;
 * - flush fermeture page ;
 * - fallback silencieux ;
 * - anti-doublon léger.
 ***********************/

const FUNNEL_BATCH_ENDPOINT =
  "https://script.google.com/macros/s/AKfycbzeJLQzU0FXQ4Twfb8yeyrT4qm5fUoygDUoRRU8ydPj-p3ijmulokgBJhnsTirtcWcJcA/exec";

const FUNNEL_SECRET =
  "MDL_FUNNEL_SECRET_2026_X7P9";

/*
|--------------------------------------------------------------------------
| CONFIG
|--------------------------------------------------------------------------
*/

const FLUSH_INTERVAL_MS = 30000;
const MAX_BATCH_SIZE = 25;

/*
|--------------------------------------------------------------------------
| MÉMOIRE LOCALE
|--------------------------------------------------------------------------
*/

let funnelQueue = [];
let flushStarted = false;

/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

function getOrCreateLocalId(key) {
  try {
    const existing =
      localStorage.getItem(key);

    if (existing) {
      return existing;
    }

    const value =
      crypto?.randomUUID?.() ||
      `${key}_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2)}`;

    localStorage.setItem(key, value);

    return value;

  } catch {
    return null;
  }
}

function getOrCreateSessionId() {
  try {

    const key =
      "md_funnel_session_id";

    const existing =
      sessionStorage.getItem(key);

    if (existing) {
      return existing;
    }

    const value =
      crypto?.randomUUID?.() ||
      `session_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2)}`;

    sessionStorage.setItem(
      key,
      value
    );

    return value;

  } catch {
    return null;
  }
}

function normalizeEventName(event) {

  return String(event || "")
    .trim()
    .toLowerCase();
}

function buildBasePayload() {

  const params =
    new URLSearchParams(
      window.location.search
    );

  return {
    secret:
      FUNNEL_SECRET,

    visitor_id:
      getOrCreateLocalId(
        "md_funnel_visitor_id"
      ),

    session_id:
      getOrCreateSessionId(),

    page:
      window.location.pathname +
      window.location.search,

    source:
      params.get("src") ||
      params.get("utm_source") ||
      "direct",

    campaign:
      params.get("campaign") ||
      params.get("utm_campaign") ||
      "",

    device:
      window.innerWidth <= 768
        ? "mobile"
        : "desktop",

    language:
      navigator.language || "",

    referrer:
      document.referrer || ""
  };
}

/*
|--------------------------------------------------------------------------
| ENQUEUE
|--------------------------------------------------------------------------
*/

export function trackFunnelEventBatch(
  event,
  metadata = {}
) {

  try {

    const normalizedEvent =
      normalizeEventName(event);

    if (!normalizedEvent) {
      return;
    }

/*
 * Anti-doublon léger
 * --------------------------------------------------------
 * Évite :
 * - spam React ;
 * - double render ;
 * - double clic.
 *
 * IMPORTANT
 * --------------------------------------------------------
 * app_open :
 * - fenêtre anti-doublon plus large ;
 * - évite le spam au refresh/localhost.
 */
const now =
  Date.now();

const duplicateWindowMs =
  normalizedEvent === "app_open"
    ? 60000
    : 2500;

const duplicate =
  funnelQueue.find(function(item) {

    return (
      item.event === normalizedEvent &&
      now - item.ts < duplicateWindowMs
    );
  });

if (duplicate) {
  return;
}

    funnelQueue.push({

      ...buildBasePayload(),

      event:
        normalizedEvent,

      metadata:
        metadata || {},

      ts:
        now
    });

    /*
     * Flush immédiat sécurité
     */
    if (
      funnelQueue.length >=
      MAX_BATCH_SIZE
    ) {
      flushFunnelBatch();
    }

    /*
     * Init interval une seule fois
     */
    if (!flushStarted) {

      flushStarted = true;

      setInterval(
        flushFunnelBatch,
        FLUSH_INTERVAL_MS
      );
    }

  } catch (error) {

    console.warn(
      "[trackFunnelEventBatch]",
      error
    );
  }
}

/*
|--------------------------------------------------------------------------
| FLUSH
|--------------------------------------------------------------------------
*/

export function flushFunnelBatch() {

  try {

    if (!funnelQueue.length) {
      return;
    }

    const batch =
      funnelQueue.splice(
        0,
        MAX_BATCH_SIZE
      );

    /*
     * Nettoyage ts interne
     */
    const payload =
      batch.map(function(item) {

        const clone =
          { ...item };

        delete clone.ts;

        return clone;
      });

    console.log(
      "MDL FUNNEL BATCH",
      payload
    );

    fetch(
      FUNNEL_BATCH_ENDPOINT,
      {
        method: "POST",

        body: JSON.stringify({
          type: "funnel_batch",
          events: payload
        }),

        keepalive: true,

        mode: "no-cors"
      }
    ).catch(function(error) {

      console.error(
        "MDL FUNNEL BATCH ERROR",
        error
      );
    });

  } catch (error) {

    console.warn(
      "[flushFunnelBatch]",
      error
    );
  }
}

/*
|--------------------------------------------------------------------------
| FLUSH FERMETURE PAGE
|--------------------------------------------------------------------------
*/

window.addEventListener(
  "beforeunload",
  function() {

    try {

      flushFunnelBatch();

    } catch (e) {}
  }
);